module.exports = __webpack_public_path__ + "img/mtn_logo.ab1b10d4.png";